export default __webpack_public_path__ + "static/media/Quiken_Envios_Nacionales-04.d04205aa.svg";